import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { stringify } from "query-string";
import { Link } from "react-router-dom";
import { allowedNumberOfPrivateTopics } from "sprout-lib";
import { Alert } from "sprout-ui-dom/dist/Alert";
import { NO_TEAM } from "sprout-ui-dom/dist/Select";
import { InfoOutlined } from "sprout-ui-icons";
import { Box } from "sprout-ui-primitives";
const NewTopicPageAlert = (props)=>{
    const { team , isSelectedTeamOwner  } = props;
    const noTeamSelected = team === NO_TEAM;
    return /*#__PURE__*/ _jsxs(Alert, {
        status: "alert",
        children: [
            /*#__PURE__*/ _jsx(InfoOutlined, {}),
            /*#__PURE__*/ _jsxs(Box, {
                ml: "16px",
                children: [
                    noTeamSelected ? `You have already used your ${allowedNumberOfPrivateTopics} free private trees. To create unlimited
            private trees, ` : isSelectedTeamOwner ? `This workspace has already used its ${allowedNumberOfPrivateTopics} free private workspace trees. To create unlimited private workspace trees, ` : `This workspace has already used its ${allowedNumberOfPrivateTopics} free private workspace trees. To create unlimited private workspace trees, contact the workspace owner to upgrade this workspace`,
                    (noTeamSelected || isSelectedTeamOwner) && /*#__PURE__*/ _jsx("em", {
                        children: /*#__PURE__*/ _jsx(Link, {
                            to: noTeamSelected ? "/pricing" : {
                                pathname: "/payment",
                                search: stringify({
                                    plan_duration: "year",
                                    workspace: team
                                })
                            },
                            children: noTeamSelected ? `pay for Sprout` : `upgrade your workspace`
                        })
                    }),
                    "."
                ]
            })
        ]
    });
};
export default NewTopicPageAlert;
